/**
 * Product checkout confidence modals: open/close, body scroll lock, overlay + Escape.
 * Multiple block instances: overflow restored when last modal closes.
 */
(function () {
  if (window.__pccInit) return;
  window.__pccInit = true;

  var openCount = 0;

  function pccBodyLock() {
    openCount += 1;
    if (openCount === 1) {
      document.body.classList.add('pcc-modal-open');
    }
  }

  function pccBodyUnlock() {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
      document.body.classList.remove('pcc-modal-open');
    }
  }

  function pccGetRootFrom(node) {
    if (!node || !node.closest) return null;
    return node.closest('.pcc');
  }

  function pccOpen(root) {
    if (!root) return;
    root.removeAttribute('hidden');
    root.classList.add('is-open');
    pccBodyLock();
  }

  function pccClose(root) {
    if (!root) return;
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('hidden', '');
    pccBodyUnlock();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pcc-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('aria-controls');
      var root = id ? document.getElementById(id) : null;
      pccOpen(root);
      return;
    }

    var closer = e.target.closest('[data-pcc-close]');
    if (closer) {
      pccClose(pccGetRootFrom(closer));
      return;
    }

    var backdrop = e.target.closest('.pcc__backdrop');
    if (backdrop) {
      pccClose(pccGetRootFrom(backdrop));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.pcc.is-open');
    pccClose(open);
  });
})();
